$ = require('jquery')

getActiveTabNumByString = (nameTab) ->
  switch nameTab
    when '#timeline' then 1
    when '#event' then 2
    when '#rank' then 3
    else 1

GroupDetailCtrl = ($rootScope ,$scope ,$filter ,$location ,$route ,groupInfo ,groupStatus ,userInfo ,groupRegisDataService ) ->
  angular.element(document.body).css 'min-width', 0

  $(document).ready( ->
    document.body.scrollTop = document.documentElement.scrollTop = 0
    item = $('#groupTabs')[0]
    curOffset = item.offsetTop
    window.onscroll = ->
      if window.pageYOffset >= curOffset
        item.classList.add("sticky")
      else
        item.classList.remove("sticky")
  )

  $scope.groupDetail = groupInfo
  $scope.groupStatus = groupStatus
  $scope.userInfo = userInfo

  hash = window.location.hash
  $scope.tab = getActiveTabNumByString(hash) # set default tab

  $scope.gotoTimelineTab = ->
    $("html, body").animate({ scrollTop:0}, 400 , ->
      $scope.$apply ->
        $scope.tab = 1
    )
    return true

  $scope.gotoEventTab = ->
    $("html, body").animate({ scrollTop:0}, 400 , ->
      $scope.$apply ->
        $scope.tab = 2
    )
    return true

  $scope.gotoRankTab = ->
    $("html, body").animate({ scrollTop:0}, 400 , ->
      $scope.$apply ->
        $scope.tab = 3
    )
    return true

  $scope.displayPrivacy = (privacy) ->
    if privacy
    then $filter('translate')('_GROUP.LIST.PUBLIC_GROUP')
    else $filter('translate')('_GROUP.LIST.PRIVATE_GROUP')

  $rootScope.$on "$routeChangeStart", (event, next, current) ->
    if current.$$route.originalPath != next.$$route.originalPath &&
    next.$$route.originalPath != '/groups/search' &&
    next.$$route.originalPath != '/groups/:id'
      groupRegisDataService.setTempData(null)

GroupDetailCtrl.$inject = [
  '$rootScope'
  '$scope'
  '$filter'
  '$location'
  '$route'
  'groupInfo'
  'groupStatus'
  'userInfo'
  'groupRegisDataService'
]

module.exports = GroupDetailCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/groups/group-detail-controller.coffee